export const GET_payment = ({ payment }) => payment;
